import { Component, ElementRef, ViewChild, Output, EventEmitter, TemplateRef, Input } from '@angular/core'
import { NbDialogService } from '@nebular/theme'
import { Dimensions, ImageCroppedEvent, ImageCropperComponent, ImageTransform } from 'ngx-image-cropper'
import { OutputFormat } from 'ngx-image-cropper/lib/interfaces/cropper-options.interface'
import { SharedService } from '../../@core/services/shared.service'

@Component({
    templateUrl: './choose-avatar.component.html',
    styleUrls: ['./choose-avatar.component.scss'],
    selector: 'app-choose-avatar',
})
export class ChooseAvatarComponent {
    @Input()
    ratio: number = 4 / 3 // square
    @Input()
    resizeToWidth: number = 1600
    @Input()
    format: OutputFormat = 'jpeg'

    @Output('fileChanged')
    fileChanged: EventEmitter<File> = new EventEmitter()

    @ViewChild('fileInput')
    fileInput: ElementRef
    @ViewChild('dialog', { static: true }) dialog: TemplateRef<any>
    @ViewChild(ImageCropperComponent) icc: ImageCropperComponent

    cropperMinWidth: number = 168
    imageChangedEvent: any = ''
    croppedImage: string = ''
    canvasRotation: number = 0
    scale: number = 1
    containWithinAspectRatio: boolean = false
    transform: ImageTransform = {}
    base64: string
    showCropper: boolean = false
    showSpinner: boolean = true

    constructor(private sharedService: SharedService, private dialogService: NbDialogService) {}

    click() {
        this.fileInput.nativeElement.click()
    }

    openCropDialog() {
        this.showSpinner = true
        this.showCropper = false
        switch (this.ratio) {
            case 3 / 4: {
                this.resizeToWidth = 1200
                break
            }
            case 16 / 9: {
                this.resizeToWidth = 1920
                break
            }
            default: {
                this.resizeToWidth = 1600
            }
        }
        this.dialogService.open(this.dialog).onClose.subscribe((res) => {
            if (res) {
                this.fileChanged.emit(this.base64ToFile(this.base64))
            }
        })
    }

    fileChangeEvent(event: any): void {
        this.imageChangedEvent = event
        this.openCropDialog()
    }

    base64ToFile(base64Image: string): File {
        const split = base64Image.split(',')
        const type = split[0].replace('data:', '').replace(';base64', '')
        const byteString = atob(split[1])
        const ab = new ArrayBuffer(byteString.length)
        const ia = new Uint8Array(ab)
        for (let i = 0; i < byteString.length; i += 1) {
            ia[i] = byteString.charCodeAt(i)
        }
        const b = new Blob([ab], { type })
        return new File([b], `cropped.${this.format}`, { lastModified: new Date().getTime(), type: b.type })
    }

    imageCropped(event: ImageCroppedEvent) {
        this.croppedImage = event.base64
        console.log('Image cropped', event, this.base64ToFile(event.base64))
    }

    imageLoaded() {
        this.showSpinner = false
        this.showCropper = true
        console.log('Image loaded')
    }

    cropperReady(sourceImageDimensions: Dimensions) {
        console.log('Cropper ready')
    }

    loadImageFailed() {
        console.log('Load failed')
        this.sharedService.showErrorMessage('Load image failed!')
    }

    rotateLeft() {
        this.showSpinner = true
        this.showCropper = false
        this.canvasRotation--
        this.flipAfterRotate()
        this.showCropper = true
        this.showSpinner = false
    }

    rotateRight() {
        this.showSpinner = true
        this.showCropper = false
        this.canvasRotation++
        this.flipAfterRotate()
    }

    private flipAfterRotate() {
        const flippedH = this.transform.flipH
        const flippedV = this.transform.flipV
        this.transform = {
            ...this.transform,
            flipH: flippedV,
            flipV: flippedH,
        }
    }

    flipHorizontal() {
        this.transform = {
            ...this.transform,
            flipH: !this.transform.flipH,
        }
    }

    flipVertical() {
        this.transform = {
            ...this.transform,
            flipV: !this.transform.flipV,
        }
    }

    onDialogOk() {
        this.showSpinner = true
        // do crop
        const event = this.icc.crop()
        this.base64 = event.base64
    }
}
